/**
 * Provides svg caching functionality to avoid redundant XHR requests.
 * When the retrieved item doesn't exist in cache yet, a request is sent
 * to its 'src' url. The request's promise is cached for that 'src' key
 * and can be used for the whole session without repeating requests.
 */
class Cache {
    constructor() {
        Object.defineProperty(this, "cache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "add", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (src, svg) => {
                this.cache.set(src, svg);
            }
        });
        Object.defineProperty(this, "get", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (src) => {
                const item = this.cache.get(src);
                if (!item) {
                    const promise = fetch(src).then(res => res.text());
                    this.add(src, promise);
                    return promise;
                }
                return item;
            }
        });
        Object.defineProperty(this, "reset", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.cache.clear();
            }
        });
    }
}
const cache = new Cache();
export default cache;
